<script>
import { Bar } from 'vue-chartjs'
import moment from '@/plugins/moment'
import { settingsColors } from '@/assets/chartsSettings.js'
import { mapState } from 'vuex'
export default {
  extends: Bar,
  props: ['chartData', 'colors', 'configs'],
  data() {
    return {
      unit_time: {}
    }
  },
  computed: {
    ...mapState('general', ['language'])
  },
  watch: {
    configs: {
      deep: true,
      handler: 'rerender'
    }
  },
  mounted() {
    moment.locale(this.language)
    this.rerender()
  },
  methods: {
    rerender() {
      if (!this.chartData || !this.chartData.datasets) {
        return
      }
      const chart = this.chartData
      if (this.colors) {
        chart.datasets.forEach(el => {
          for (let key in this.colors) {
            if (key === el.label) {
              Object.assign(el, {
                backgroundColor: 'rgba(0, 0, 0, 0)',
                borderColor: `rgba(${this.colors[key]}, 1)`,
                borderWidth: 1
              })
            }
          }
        })
      } else {
        chart.datasets.forEach((el, i) => {
          let color = el.color
            ? el.color
                .replace('rgb(', '')
                .replace('rgba(', '')
                .replace(')', '')
            : settingsColors[i]
          if (!color) {
            const [R, G, B] = [
              Math.floor(Math.random() * 255),
              Math.floor(Math.random() * 255),
              Math.floor(Math.random() * 255)
            ]
            color = `${R}, ${G}, ${B}`
          }

          const borderColor = el.data.map(() => {
            return `rgba(${color}, 1)`
          })
          const backgroundColor = el.data.map(() => {
            return `rgba(${color}, 1)`
          })

          Object.assign(el, {
            backgroundColor,
            borderColor,
            borderWidth: 1
          })
        })
      }

      const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: this.configs.parameters['Legend position'],
          display: this.configs.parameters['Legend position'] != 'off'
        } // ,
        // title: {
        //   display: this.configs.parameters['Display title'],
        //   text: this.configs.name
        // }
      }
      this.renderChart(chart, options)
    }
  }
}
</script>
<style lang="scss">
.dashboard-widget > div {
  width: 100% !important;
  height: 100% !important;
}
</style>
